<div class="container">
    <div class="title">
        {{ 'dlg.duplicate-destiantion' | translate }}
    </div>
    <div class="sub-label">{{ 'dlg.duplicate-destiantion.message' | translate }}</div>
    <div class="content-container">
        <div class="input-container">
            <div class="input-title">
                {{ 'dlg.destination' | translate }}
            </div>
            <app-simple-dropdown
                style="height: 56px"
                [options]="data.options"
                [selectedOption]="destination"
                (onOptionSelected)="handleDestinationChange($event)">
            </app-simple-dropdown>
        </div>
    </div>
    <div class="footer">
        <div class="text-button" (click)="closeDialog()">
            {{ 'dlg.cancel' | translate }}
        </div>
        <div class="text-button save-button" (click)="save()" [class.save-disable]="isSaveDisabled()">
            {{ 'dlg.save' | translate }}
        </div>
    </div>
</div>
